import { useIsOwner, useSessionPermission } from '@btime/react-session'

import { SETTINGS } from '../../../modules/integrations/_services/services'
import { getWorkspace } from '../../session/sessionStorage'
import { useNavigationWithModalCloser } from '../../contexts/NavigationContext'
import { useRemoveIntegrations } from './_requests/removeIntegrations'
import { useOpenAddSegwareTechnicianModal, useSegwareTechnicianModal } from '../../routes/modals/modalsActions'

// TODO - Create a detail modal - will be great to see which permission the integration has
// export const useIntegrationDetailAction = item => {
//   const openDetailsModal = useOpenIntegrationModal()
//   return { click: () => openDetailsModal(item) }
// }

export const useIntegrationLogsAction = item => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityIntegrationIds=${item.id}`),
    link: `/logs?entityIntegrationIds=${item?.id}`,
    hasPermission: isOwner
  }
}

export const useIntegrationReinstallAction = item => {
  const config = SETTINGS[item?.service]
  const workspace = getWorkspace()

  const handleReinstall = config?.onReinstall({ ...config, item })

  const canReinstall = useSessionPermission('editIntegration')

  return {
    click: () => handleReinstall({ id: item.id }),
    hasPermission: canReinstall
  }
}

export const useIntegrationRemoveAction = item => {
  const canDelete = useSessionPermission('deleteIntegration')
  const [deleteItems, { loading }] = useRemoveIntegrations()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

export const useIntegrationsLogsAction = ids => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityIntegrationIds=${ids?.join(',')}`),
    link: `/logs?entityIntegrationIds=${ids?.join(',')}`,
    hasPermission: isOwner
  }
}

export const useIntegrationsRemoveAction = ids => {
  const canDelete = useSessionPermission('deleteIntegration')
  const [deleteItems, { loading }] = useRemoveIntegrations()

  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}

export const useIntegrationsAddSegwareTechnicianAction = item => {
  const canReinstall = useSessionPermission('editIntegration')
  const openModal = useOpenAddSegwareTechnicianModal()

  return {
    click: () => openModal(item),
    hasPermission: canReinstall && item?.service === 'segware'
  }
}

export const useIntegrationsListTechniciansAction = item => {
  const canReinstall = useSessionPermission('editIntegration')
  const openModal = useSegwareTechnicianModal()

  return {
    click: () => openModal(item),
    hasPermission: canReinstall && item?.service === 'segware'
  }
}
